<template>
  <edit v-if="record" :record="record" @onGoBack="handleGoBack" :editMode="true"></edit>
</template>

<script>
import CustomerApi from '@/api/api-cdb-custome-v2'
// 动态切换组件
import Edit from './CdbCustomerEdit'

export default {
  name: 'EditCdbCustomerPage',
  components: {
    Edit
  },
  data () {
    return {
      record: null,
    }
  },
  created () {
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      const customerIdOrCode = this.$route.params.customerIdOrCode
      try {
        const recordRes = await CustomerApi.detail(customerIdOrCode)
        this.record = recordRes.data
      } catch (e) {
        if (e.message === 'Request failed with status code 404') {
          this.$router.replace('/404')
        }
      }
    },
    handleGoBack () {
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
    },
    record (val) {
      this.record = val
    }
  }
}
</script>
